var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',[_c('b',[_vm._v("小熊后台")]),_vm._v(" v1.0.0 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }